module.exports = __webpack_public_path__ + "img/image_11.5fbac4db.png";